import { render, staticRenderFns } from "./InlineRender.vue?vue&type=template&id=6e48712c&lang=pug&"
import script from "./InlineRender.vue?vue&type=script&lang=js&"
export * from "./InlineRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports